const AggressorSubpoena = {
    options: [
        {value: "PENDING", label: "Pendente"},
        {value: "DONE", label: "Cumprido"},
    ],

    toOption: (value) => {
        if (!value) return null;

        return AggressorSubpoena.options.find(option => option.value === value)
    },

    optionsToView: (value) => {
        if (!value) return null;

        return value.label
    }
};

export default AggressorSubpoena;
